module.exports = __webpack_public_path__ + "app/bento-components/video-list/media/icon.svg?137c721d60faa2d1c739e2d313cfb89f";